import React from 'react'
import styled from 'styled-components'

// components
import Paging from '../../../components/pagination/Paging'
import DropDown from '../../../components/dropdown/DropDown'

// utils
import { getComma } from '../../../utils/getComma'

// styles
import colors from '../../../styles/colors'

// images
import DownloadImg from '../../../assets/image/download/ic-green-download.svg'

const TABLE_HEADER_ITEM = [
  '정산기간',
  '상품대금',
  '정산대상금',
  '배달비',
  '채널이용수수료',
  '부가세',
  '결제수수료\n(상품대금)',
  '부가세',
  '결제수수료\n(배달비)',
  '부가세',
  '총 정산금액',
  '정산명세서',
]

function Table({ size, page, settlementItem, setSize, setPage, handleExcel }) {
  const changePage = (page) => {
    setPage(page)
  }

  return (
    <Container>
      <TitleWrapper>
        {/* <ExcelTitle onClick={handleExcel}>
          <img src={DownloadImg} />
          <span>정산명세서</span>
        </ExcelTitle> */}
        <SelectTitle>
          <DropDown
            options={[10, 20, 50]}
            setOption={setSize}
            value={size}
            isPageUnit={true}
          />
        </SelectTitle>
      </TitleWrapper>
      <TableWrapper>
        <TableHeader>
          {TABLE_HEADER_ITEM.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </TableHeader>

        {settlementItem?.list &&
          settlementItem?.list.map((item, idx) => (
            <TableBody key={idx}>
              <li>{`${item?.summaryYear ?? ''}년 ${
                item?.summaryMonth ?? ''
              }월 ${item?.summaryChasu ?? ''}차`}</li>
              <li>{`${getComma(item?.goodsPayment)}원`}</li>
              <li>{`${getComma(item?.calculationPayment)}원`}</li>
              <li>{`${getComma(item?.deliveryCharge)}원`}</li>
              <li>{`${getComma(item?.channelUseCommission)}원`}</li>
              <li>{`${getComma(item?.channelUseSurtax)}원`}</li>
              <li>{`${getComma(item?.goodsPaymentCommission)}원`}</li>
              <li>{`${getComma(item?.goodsPaymentSurtax)}원`}</li>
              <li>{`${getComma(item?.deliveryCommission)}원`}</li>
              <li>{`${getComma(item?.deliverySurtax)}원`}</li>
              <li>{`${getComma(item?.totalCalculateAmount)}원`}</li>
              <li>
                <img src={DownloadImg} onClick={() => handleExcel(item)} />
              </li>
            </TableBody>
          ))}

        <Paging
          page={page}
          count={settlementItem.total}
          setPage={(e) => changePage(e)}
          isTemp={true}
          tableSize={size}
          marginTop={[40, 17]}
        />
      </TableWrapper>
    </Container>
  )
}

export default Table

const Container = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;

  display: flex;
  flex-direction: column;
  position: relative;

  /* padding-top: 30px; */

  .pagination {
    position: absolute;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;

  @media ${(props) => props.theme.mobile} {
    justify-content: space-between;
    margin-bottom: 11px;
  }
`

const ExcelTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  span {
    color: ${colors.mainG};
    font-size: 16px;
    margin-top: 4px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
`

const SelectTitle = styled.div`
  /* margin-left: 35px; */

  .dropdown {
    flex: 1;
    margin-bottom: 0px !important;

    .show {
      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }

    button {
      width: 162px;

      @media ${(props) => props.theme.mobile} {
        width: 125px;
        font-size: 14px;
      }
    }
  }
`

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 70px;

  @media ${(props) => props.theme.mobile} {
    padding-bottom: 63px;
  }

  /* scroll */
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: ${colors.G2};
  }

  &::-webkit-scrollbar-track {
    border: 1px solid ${colors.G2};
  }
`

const TableHeader = styled.div`
  display: flex;
  white-space: pre-line;

  li {
    /* scroll */
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    border-top: 1px solid ${colors.G3};
    border-bottom: 1px solid ${colors.G3};
    background-color: ${colors.W4};
    color: ${colors.D3};
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    @media ${(props) => props.theme.mobile} {
      height: 39px;
      font-size: 11px;
      line-height: 14px;
    }

    :nth-child(1) {
      min-width: 140px;
    }

    :nth-child(n + 2):nth-child(-n + 12) {
      min-width: 110px;
    }
  }
`

const TableBody = styled.div`
  display: flex;

  li {
    /* scroll */
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid ${colors.W4};
    font-size: 16px;
    color: ${colors.BK};

    @media ${(props) => props.theme.mobile} {
      padding: 14px 0;
      font-size: 12px;
    }

    :nth-child(1) {
      min-width: 140px;
    }

    :nth-child(n + 2):nth-child(-n + 12) {
      min-width: 110px;
    }
  }

  img {
    cursor: pointer;
  }
`
